export const initScrollToProductInListing = (): void => {
  window.addEventListener('load', () => {
    if (window.location.href.includes('/collections/') && !window.location.href.includes('/products/')) {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

      const storedProductTitle: string = localStorage.getItem('bbLastVisitedProductTitle');

      // Add delay to avoid scroll location jumping after some images load
      setTimeout(() => {
        if (storedProductTitle) {
          // Add offset for navbar
          const yOffset = -233; 
  
          const productCardLink: HTMLElement = document.querySelector(`[title="${storedProductTitle}"]`);
  
          // The product card's top plus the offset
          const prodCardY: number = productCardLink.parentElement.parentElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
  
          window.scrollTo({top: prodCardY});
  
          localStorage.removeItem('bbLastVisitedProductTitle');
        }
      }, 500)
    }
  })
}